var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMailClosedFill = function SvgMailClosedFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21.6v21.6H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.614 4.158H4.986c-.55 0-1.077.216-1.467.603a2.052 2.052 0 0 0-.612 1.467v9.144c-.001.551.22 1.08.612 1.467.39.39.916.61 1.467.612h11.628a2.088 2.088 0 0 0 1.467-.612c.393-.387.613-.916.612-1.467V6.228a2.052 2.052 0 0 0-.612-1.467 2.079 2.079 0 0 0-1.467-.603zm-1.395 3.321-3.933 3.24a.801.801 0 0 1-.486.171.783.783 0 0 1-.486-.171l-3.933-3.24a.477.477 0 0 1-.153-.279.468.468 0 0 1 .072-.306.324.324 0 0 1 .126-.099.576.576 0 0 1 .162-.054.495.495 0 0 1 .162 0 .459.459 0 0 1 .144.081l3.906 3.213 3.888-3.195a.459.459 0 0 1 .144-.081.495.495 0 0 1 .315.054c.048.025.09.059.126.099.036.041.06.09.072.144a.333.333 0 0 1 0 .162.306.306 0 0 1-.045.153.324.324 0 0 1-.081.108z",
    fill: "#D5D7E2",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMailClosedFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail-closed-fill.7297d212.svg";
export { ForwardRef as ReactComponent };